module.exports = __webpack_public_path__ + "img/parent-cat-4.79573e94.svg";